export default {
  'sold-out': "Il n'est pas possible de commander plus pour ce créneau de livraison",
};
